import { Version } from "./version";

export const FUSE_VERSION = new Version('15.0.0').full;
